<template>
  <div>
    <h4>{{value.name}}</h4>
    <slot></slot>
		<a :href="$voidHref" @click="loadData">🔄 Refresh Data</a>
    <BasicTableComponent :list="list" :formatters="listFormatters" :titles="listTitles"/>
    <!-- <BasicTableComponent :list="list" /> -->
  </div>
</template>

<script>
export default {
	name:'SQLReport',
  props: ['value'],
  props: {
    value: String,
    listFormatters: {
      type: Object,
      default: () => {}
    },
    listTitles: {
      type: Object,
      default: () => {}
    }
  },
  data () {return {
    list: [],
  }},
  created () {
    this.loadData()
  },
  methods:{
    loadData: function(){
      this.list = [];
      const options = {
        sql: this.value.sql,
        // key: localStorage.getItem('_key')
      }
      this.$axios.post(`/sql/${this.value.location}`, options)
      .then((a)=>this.list = a.data)
      .catch((err)=>console.log(err))
    }
  }
  
}
</script>

<style>

</style>
